import { useEffect, useRef } from 'react';

const LOOP_TIMEOUT_MS = 30000; // 30 second timeout
const LOOP_TIMER_MS = 250; // check every 250ms

export const useWatchForAndCloseCookieBanner = (active: boolean) => {
  const timeout = useRef(0);

  // If we're active, set a timeout. The banner should have shown by then.
  useEffect(() => {
    if (active) {
      timeout.current = Date.now() + LOOP_TIMEOUT_MS;
    }
  }, [active]);

  // Watch for cookie banner and close it
  useEffect(() => {
    if (active) {
      let loop: number;

      const checkAndCloseCookieBanner = () => {
        if (window.OneTrust && !window.OneTrust.IsAlertBoxClosed()) {
          window.OneTrust.Close();
          window.clearInterval(loop);
          return true;
        }

        // Give up watching after a while
        if (Date.now() > timeout.current) {
          window.clearInterval(loop);
          return true;
        }

        return false;
      };

      if (!checkAndCloseCookieBanner()) {
        loop = window.setInterval(checkAndCloseCookieBanner, LOOP_TIMER_MS);
        return () => {
          window.clearInterval(loop);
        };
      }
    }
  });
};
